import React from "react";
import { connect } from "react-redux";
import { closeTaskDetailModel } from "../actions";
import mainHelper, {apiCall} from "../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";

class TaskDetailModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title:'',
      description:'',
      selectedAssignedUsers:[],
      loading: false
    };
  }
  componentDidMount() {
    const {assignedUsers} = this.props.taskModalData;
    const formattedSelectedOptions = assignedUsers.map(option => ({
      value: option.id,
      label: option.name+' '+option.surname
    }));
    const {title, description, } = this.props.taskModalData;
    this.setState({selectedAssignedUsers:formattedSelectedOptions,title:title,description:description})
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  handleSelectChange = (selectedAssignedUsers) => {
    const formattedSelectedOptions = selectedAssignedUsers ? selectedAssignedUsers.map(option => ({
      value: option.value,
      label: option.label
    })) : [];

    this.setState({
      selectedAssignedUsers: formattedSelectedOptions
    });
  };
  handleUpdateTask = async (event) => {
    event.preventDefault();
    const {taskID} = this.props.taskModalData;
    this.setState({ loading: true });
    const {title, selectedAssignedUsers, description } = this.state;
    const formattedSelectedUsers = selectedAssignedUsers.map(item=>item.value)
    try {
      const response = await apiCall('business/tasks/update/'+taskID, 'post', {
        title: title,
        assigned_user_ids: formattedSelectedUsers,
        description: description,
      });
      await this.props.fetchTasks();
      this.setState({ loading: false });
      mainHelper.toastMessage('success', response.message);
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { isTaskDetailModalOpen } = this.props;
    const { employees } = this.props.taskModalData;
    const { loading ,selectedAssignedUsers,title, description,} = this.state;
    const formattedOptions = employees.map(option => ({
      value: option.id,
      label: option.name+' '+option.surname
    }));


    return (
        <div className={isTaskDetailModalOpen ? "modal fade show" : "modal fade"} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="title" id="defaultModalLabel">Görev Detayları</h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="title"
                        id="title"
                        type="text"
                        className="form-control"
                        placeholder="Görev başlığı"
                        value={title || ''}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                  <textarea
                      name="description"
                      id="description"
                      className="form-control"
                      placeholder="Görev detayı"
                      value={description || ''}
                      onChange={this.handleInputChange}
                  ></textarea>
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <Select
                        isMulti
                        placeholder="Atanacak kullanıcıları Seçiniz..."
                        options={formattedOptions}
                        value={selectedAssignedUsers}
                        onChange={this.handleSelectChange}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {loading ? (
                    <button
                        className="btn btn-outline-primary btn-lg"
                        disabled={true}
                        style={{textAlign: "-webkit-center"}}
                    >
                      Lütfen Bekleyin...
                      <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"/>
                    </button>
                ) : (
                    <button type="button" className="btn btn-outline-primary" onClick={this.handleUpdateTask}>
                      Güncelle
                    </button>
                )}
                <button
                    type="button"
                    onClick={this.props.closeTaskDetailModel}
                    className="btn btn-simple"
                    data-dismiss="modal"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({
  isTaskDetailModalOpen: mailInboxReducer.isTaskDetailModalOpen,
  taskModalData: mailInboxReducer.taskModalData
});

export default connect(mapStateToProps, {closeTaskDetailModel})(TaskDetailModel);
